import { render, staticRenderFns } from "./works.vue?vue&type=template&id=6a26d00b&"
import script from "./works.vue?vue&type=script&lang=js&"
export * from "./works.vue?vue&type=script&lang=js&"
import style0 from "./works.vue?vue&type=style&index=0&id=6a26d00b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a26d00b')) {
      api.createRecord('6a26d00b', component.options)
    } else {
      api.reload('6a26d00b', component.options)
    }
    module.hot.accept("./works.vue?vue&type=template&id=6a26d00b&", function () {
      api.rerender('6a26d00b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/works/works.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/works/works.vue
// module id = ZFEY
// module chunks = 0